import request from '@/utils/request'

// 所有商品分类
export const categoryListAll = (type) => {
    return request.get(`/goods/category${type ? '?type=' + type : ''}`)
}
